var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SvgIcon',{attrs:{"icon-class":`signal-${_vm.type}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }